const metricDistanceUnits = ['mm', 'cm', 'm', 'km']
/**
 * Checks if a given the distance unit is a metric distance unit
 * @param { string } distanceUnit distance unit.
 * @returns { boolean } true or false either the used unit is metric or not
 */
export function isMetricDistanceUnit(distanceUnit) {
    return metricDistanceUnits.some(metricUnit => metricUnit === distanceUnit)
}
